/**
 * Platform-aware modifier key labels for shortcut hints.
 *
 * Handlers use `metaKey || ctrlKey` (both fire). Display must not hardcode ⌘ —
 * B2B users are mostly on Windows/Linux where the chord is Ctrl.
 *
 * RECON-SHORTCUT-PLATFORM-1: Header ⌘K was also hardcoded; use these helpers.
 */

export type ModNavLike = Pick<Navigator, "platform" | "userAgent">;

/** True when the OS uses ⌘ as the primary shortcut modifier (Apple). */
export function isAppleModPlatform(
  nav: ModNavLike | undefined =
    typeof navigator !== "undefined" ? navigator : undefined,
): boolean {
  if (!nav) return false;
  const platform = String(nav.platform ?? "");
  const ua = String(nav.userAgent ?? "");
  // Prefer platform; fall back to UA (jsdom often has empty/generic platform).
  return /Mac|iPhone|iPad|iPod/i.test(platform) || /Mac OS X|Macintosh|iPhone|iPad|iPod/i.test(ua);
}

/** Modifier glyph/word for UI: ⌘ on Apple, Ctrl elsewhere. */
export function modKeyLabel(nav?: ModNavLike): string {
  return isAppleModPlatform(nav) ? "⌘" : "Ctrl";
}

/** Sidebar close chord as shown in tooltips (matches resize-handle copy). */
export function formatModBackslashChord(nav?: ModNavLike): string {
  return isAppleModPlatform(nav) ? "⌘ \\" : "Ctrl+\\";
}

/** Command-palette / Header search chord. */
export function formatModKChord(nav?: ModNavLike): string {
  return isAppleModPlatform(nav) ? "⌘K" : "Ctrl+K";
}
